import { makeStyles } from "@material-ui/core/styles";

const useHeaderStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: "rgba(10, 22, 40, 0.85)",
    backdropFilter: "blur(12px)",
    boxShadow: "none",
    transition: "background-color 0.4s ease, box-shadow 0.4s ease",
  },
  headerScrolled: {
    backgroundColor: "rgba(10, 22, 40, 0.98)",
    boxShadow: "0 4px 30px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 212, 170, 0.1)",
  },
  
  // Flexbox container for header
  headerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(1.5, 0),
    maxWidth: "100%",
    width: "100%",
    margin: "0 auto",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1, 1.5),
    },
  },
  
  // Logo section
  logoSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexShrink: 0,
    minWidth: "auto",
  },
  
  logo: {
    height: "40px",
    width: "auto",
    display: "block",
    [theme.breakpoints.down("sm")]: {
      height: "32px",
    },
  },
  
  // Navigation menu
  navMenu: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: theme.spacing(1),
    flexGrow: 1,
    marginLeft: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  
  dropdownContainer: {
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  
  expandIcon: {
    marginLeft: "4px !important",
    fontSize: "18px !important",
    transition: "transform 0.3s ease",
  },
  
  toolbarLink: {
    padding: theme.spacing(0.75, 1.5),
    fontSize: "0.95rem",
    fontWeight: "500",
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    color: "#a0aec0",
    textTransform: "none",
    letterSpacing: "0.02em",
    textDecoration: "none",
    transition: "color 0.2s ease",
    position: "relative",
    borderRadius: "8px",
    whiteSpace: "nowrap",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    "&::before": {
      content: '""',
      position: "absolute",
      bottom: "2px",
      left: "50%",
      width: "0%",
      height: "2px",
      background: "linear-gradient(90deg, #00d4aa, #667eea)",
      transition: "width 0.2s ease",
      transform: "translateX(-50%)",
      borderRadius: "2px",
    },
    "&:hover": {
      color: "#00d4aa",
      textDecoration: "none",
      "&::before": {
        width: "40%",
      },
    },
  },
  
  activeLink: {
    color: "#00d4aa !important",
    "&::before": {
      width: "40% !important",
    },
  },
  
  toolbarButton: {
    padding: theme.spacing(0.75, 2),
    fontSize: "0.85rem",
    fontWeight: "600",
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    textTransform: "none",
    background: "linear-gradient(135deg, #00d4aa 0%, #00b894 100%)",
    color: "#0a1628",
    borderRadius: "8px",
    boxShadow: "0 4px 15px rgba(0, 212, 170, 0.3)",
    transition: "all 0.2s ease",
    whiteSpace: "nowrap",
    minWidth: "auto",
    flexShrink: 0,
    "&:hover": {
      boxShadow: "0 6px 20px rgba(0, 212, 170, 0.5)",
      background: "linear-gradient(135deg, #00d4aa 0%, #00b894 100%)",
    },
  },
  
  activeButton: {
    boxShadow: "0 0 20px rgba(0, 212, 170, 0.6), 0 4px 15px rgba(0, 212, 170, 0.3)",
  },
  
  // Dropdown menu styles
  dropdown: {
    "& .MuiMenu-paper": {
      background: "linear-gradient(135deg, rgba(26, 54, 93, 0.95) 0%, rgba(30, 40, 70, 0.95) 100%)",
      backdropFilter: "blur(10px)",
      boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2), 0 0 1px rgba(0, 212, 170, 0.2)",
      border: "1px solid rgba(0, 212, 170, 0.1)",
      borderRadius: "12px",
      marginTop: "8px",
      minWidth: "220px",
    },
  },
  
  dropdownItem: {
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    fontSize: "0.9rem",
    fontWeight: "500",
    color: "#a0aec0",
    padding: theme.spacing(1.2, 2),
    transition: "all 0.2s ease",
    "&:hover": {
      background: "rgba(0, 212, 170, 0.1)",
      color: "#00d4aa",
    },
  },
  
  // Mobile menu button
  menuButton: {
    marginLeft: "auto",
    padding: theme.spacing(0.75),
    flexShrink: 0,
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  
  menuIcon: {
    color: "#00d4aa !important",
    fontSize: "28px !important",
  },
  
  // Mobile drawer styles
  drawerPaper: {
    width: "280px",
    background: "linear-gradient(180deg, #0a1628 0%, #1a365d 100%)",
    boxShadow: "-10px 0 40px rgba(0, 0, 0, 0.3)",
  },
  
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2, 2),
    borderBottom: "1px solid rgba(0, 212, 170, 0.2)",
  },
  
  drawerLogo: {
    height: "32px",
    width: "auto",
  },
  
  closeButton: {
    marginLeft: theme.spacing(1),
  },
  
  closeIcon: {
    color: "#00d4aa !important",
  },
  
  drawerList: {
    padding: theme.spacing(2, 0),
  },
  
  drawerItem: {
    padding: theme.spacing(1.5, 2),
    margin: theme.spacing(0.5, 1),
    borderRadius: "10px",
    transition: "all 0.3s ease",
    "&:hover": {
      background: "rgba(0, 212, 170, 0.1)",
    },
  },
  
  drawerItemActive: {
    background: "rgba(0, 212, 170, 0.15)",
    borderLeft: "3px solid #00d4aa",
    paddingLeft: theme.spacing(1.7),
    "& $drawerItemText": {
      color: "#00d4aa",
    },
  },
  
  drawerItemText: {
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    fontSize: "1rem",
    fontWeight: "500",
    color: "#e8e8e8",
    transition: "color 0.3s ease",
  },
  
  drawerSubmenuItem: {
    padding: theme.spacing(1, 5),
    margin: theme.spacing(0.25, 1),
    borderRadius: "8px",
    transition: "all 0.3s ease",
    "&:hover": {
      background: "rgba(0, 212, 170, 0.08)",
    },
  },
  
  drawerSubmenuText: {
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    fontSize: "0.9rem",
    fontWeight: "400",
    color: "#b0b8c0",
    transition: "color 0.3s ease",
  },
}));

export default useHeaderStyles;
